exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".button-outline[data-v-577d8c87] {\n  border: 2px solid;\n  height: 62px;\n}\n@media screen and (min-width: 900px) {\n.button-outline[data-v-577d8c87] {\n    border: 2px solid;\n    min-width: 220px;\n}\n}\n.dark[data-v-577d8c87] {\n  border: 1px solid #828282;\n}\n.dark[data-v-577d8c87]:hover, .dark[data-v-577d8c87]:focus {\n    color: #fff;\n    background: #000;\n    border-color: #000;\n}\n.light[data-v-577d8c87]:hover, .light[data-v-577d8c87]:focus {\n  color: #000;\n  background: #fff;\n  border-color: #fff;\n}\n", ""]);

// exports
